module.exports = __WEBPACK_EXTERNAL_MODULE_89__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 89
// module chunks = 0